import { useTranslation } from 'react-i18next';

import type { SchedulePreviewItem, ScheduleRunItem } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { TableCell, TableRow } from '@nucleus-commerce/ui/components/table';

import { runItemReasonLabel } from './run-item-labels';

const ACTION_TONE: Record<ScheduleRunItem['action'], string> = {
  publish: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  unpublish: 'border-border text-muted-foreground',
  keep: 'bg-primary/10 text-foreground border-transparent',
  skip: 'bg-warning/20 text-warning-foreground border-transparent dark:bg-warning/25',
  release: 'border-border text-muted-foreground',
};

/** One product in one store of a run or a preview: what happens and why. */
export function RunItemRow({
  item,
  storeName,
}: {
  item: ScheduleRunItem | SchedulePreviewItem;
  storeName: string;
}) {
  const { t } = useTranslation(['schedules', 'errors']);
  const reason = runItemReasonLabel(t, item.reason);
  return (
    <TableRow>
      <TableCell className="max-w-64">
        <span className="block truncate font-medium">
          {item.product?.title ?? t('schedules:runs.deletedProduct')}
        </span>
        {item.product ? (
          <code className="text-muted-foreground block truncate text-xs">
            {item.product.handle}
          </code>
        ) : null}
      </TableCell>
      <TableCell>{storeName}</TableCell>
      <TableCell>
        <Badge variant="outline" className={ACTION_TONE[item.action]}>
          {t(`schedules:action.${item.action}`)}
        </Badge>
      </TableCell>
      <TableCell className="text-muted-foreground text-xs whitespace-normal">
        {reason ?? '—'}
        {item.overridden ? <span className="block">{t('schedules:runs.overridden')}</span> : null}
      </TableCell>
    </TableRow>
  );
}
